"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.idColumn = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const __1 = require("..");
const idColumn = (options) => {
    var _a;
    return ({
        Header: (_a = options === null || options === void 0 ? void 0 : options.Header) !== null && _a !== void 0 ? _a : (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Table/Column:Id', defaultMessage: 'ID' })),
        accessor: 'id',
        headerClasses: [`${__1.className}__id`],
        disableSortBy: options === null || options === void 0 ? void 0 : options.disableSortBy,
        hidden: options === null || options === void 0 ? void 0 : options.hidden,
    });
};
exports.idColumn = idColumn;
//# sourceMappingURL=idColumn.js.map